<nz-spin [nzSpinning]="isSpinning">
  <div class="page-content container">
    <div class="title-box">
      <span class="title">{{ "DICTIONARY_MANAGEMENT" | translate }}</span>
      <button
        nz-button
        nzType="primary"
        (click)="isVisible = true"
        class="margin-left-auto add"
      >
        <bcsc-digi-icon type="digi-big-plus"></bcsc-digi-icon>
        <span>{{ "ADD" | translate }}</span>
      </button>
    </div>
    <div class="filter-box">
      <div class="filter-list">
        <div class="filter-item">
          <span>{{ "DICTIONARY_TYPE" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearType">
            <input
              nz-input
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'DICTIONARY_TYPE' | translate }
              "
              [(ngModel)]="params.dictType"
            />
          </nz-input-group>
          <ng-template #inputClearType>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.dictType"
              (click)="params.dictType = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "DICTIONARY_KEY" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearKey">
            <input
              nz-input
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'DICTIONARY_KEY' | translate }
              "
              [(ngModel)]="params.dictKey"
            />
          </nz-input-group>
          <ng-template #inputClearKey>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.dictKey"
              (click)="params.dictKey = ''"
            ></i>
          </ng-template>
        </div>
        <div class="filter-item">
          <span>{{ "DICTIONARY_VALUE" | translate }}</span>
          <nz-input-group [nzSuffix]="inputClearVal">
            <input
              nz-input
              [placeholder]="
                'PLACEHOLDER_PLEASE_INPUT'
                  | translate : { name: 'DICTIONARY_VALUE' | translate }
              "
              [(ngModel)]="params.dictValue"
            />
          </nz-input-group>
          <ng-template #inputClearVal>
            <i
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              *ngIf="params.dictValue"
              (click)="params.dictValue = ''"
            ></i>
          </ng-template>
        </div>
      </div>
      <div class="filter-ctrl">
        <button nz-button nzType="primary" (click)="onSearch()">
          <i nz-icon nzType="search" nzTheme="outline"></i>
          <span>{{ "SEARCH" | translate }}</span>
        </button>
        <button nz-button nzType="default" (click)="onClear()">
          <i nz-icon nzType="close" nzTheme="outline"></i>
          <span>{{ "CLEAR" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="container">
      <nz-table
        #basicTable
        [nzData]="dataSource"
        [nzFrontPagination]="false"
        [nzServerRender]="true"
        [nzTotal]="pagination.total"
        [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize"
        [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        [nzScroll]="{ y: 'calc(100vh - 380px)' }"
        nzShowSizeChanger
        nzShowQuickJumper
        [nzShowTotal]="totalTemplate"
        [nzWidthConfig]="widthConfig"
      >
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.name | translate }}</th>
            <th>{{ "OPERATIONS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td *ngFor="let col of columns">
              <ng-container *ngIf="col.key !== 'dictValue'">
                <span>{{ data[col.key] }}</span>
              </ng-container>
              <ng-container *ngIf="col.key === 'dictValue'">
                <span [title]="data[col.key]" class="two-lines-ellipsis">{{
                  data[col.key]
                }}</span>
              </ng-container>
            </td>
            <td class="opreations">
              <i
                nz-icon
                nzType="edit"
                nzTheme="outline"
                (click)="onEditUser(data)"
                nz-tooltip
                [nzTooltipTitle]="'EDIT' | translate"
              ></i>
              <i
                nz-icon
                nzType="delete"
                nzTheme="outline"
                nz-popconfirm
                [nzPopconfirmTitle]="
                  'DELETE_DICTIONARY_POP_CONFIRM' | translate
                "
                (nzOnConfirm)="onDelete(data)"
                nzPopconfirmPlacement="topLeft"
                nz-tooltip
                [nzTooltipTitle]="'DELETE' | translate"
              ></i>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
      }}</ng-template>
    </div>
  </div>
</nz-spin>
<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="'NEW_ADD_DICTIONARY' | translate"
  (nzOnCancel)="onCancel()"
  (nzOnOk)="onSave()"
  nzWidth="808px"
>
  <ng-container *nzModalContent>
    <form
      nz-form
      [formGroup]="validateModuleForm"
      (ngSubmit)="isVisible = false"
    >
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="dictType">{{
          "DICTIONARY_TYPE" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="
            'PLACEHOLDER_PLEASE_INPUT'
              | translate : { name: 'DICTIONARY_TYPE' | translate }
          "
        >
          <input
            nz-input
            formControlName="dictType"
            id="dictType"
            [placeholder]="
              'PLACEHOLDER_PLEASE_INPUT'
                | translate : { name: 'DICTIONARY_TYPE' | translate }
            "
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzRequired nzFor="dictKey">{{
          "DICTIONARY_KEY" | translate
        }}</nz-form-label>
        <nz-form-control
          [nzSm]="20"
          [nzXs]="24"
          [nzErrorTip]="
            'PLACEHOLDER_PLEASE_INPUT'
              | translate : { name: 'DICTIONARY_KEY' | translate }
          "
        >
          <input
            nz-input
            formControlName="dictKey"
            id="dictKey"
            [placeholder]="
              'PLACEHOLDER_PLEASE_INPUT'
                | translate : { name: 'DICTIONARY_KEY' | translate }
            "
          />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="dictValue">{{
          "DICTIONARY_VALUE" | translate
        }}</nz-form-label>
        <nz-form-control [nzSm]="20" [nzXs]="24">
          <input
            nz-input
            formControlName="dictValue"
            id="dictValue"
            [placeholder]="
              'PLACEHOLDER_PLEASE_INPUT'
                | translate : { name: 'DICTIONARY_VALUE' | translate }
            "
          />
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
